import { PropertyType } from './property'
import { PropertyConf } from './conf/property-conf'
import { PropertySpec } from './spec/property-spec'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { DynamicPropertyConf } from './dynamic/dynamic-property-conf'
import { DynamicPropertySpec } from './dynamic/dynamic-property-spec'
import { ConstraintSpec } from '../process/capability-spec/constraints/constraint-spec'
import { ConstraintConf } from '../shopfloor/workcenters/capability/constraints/constraint-conf'

export class PropertyUtil {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private static readonly log = LoggerFactory.getLogger(PropertyUtil.name)

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public static supportsSingleSelectionSetting(propertyType: PropertyType): boolean {
    if (!propertyType) {
      return false
    }

    switch (propertyType) {
      case PropertyType.QUANTITY_ENUMERATION:
      case PropertyType.VALUE_ENUMERATION:
        return true
      case PropertyType.BOOLEAN:
      case PropertyType.NUMBER:
      case PropertyType.QUANTITY:
      case PropertyType.VALUE:
      case PropertyType.QUANTITY_LIST:
      case PropertyType.VALUE_LIST:
        return false
    }
  }

  public static populate(confs: PropertyConf[], specs: PropertySpec[]): void {
    for (const conf of confs) {
      const propSpec = specs.find((spec) => spec?.propertyId === conf?.propertyId)

      if (propSpec) {
        conf.spec = propSpec
      } else {
        this.log.warn('Failed to populate. Could not find PropertySpec with id ' + conf?.propertyId)
      }
    }
  }

  public static populateDynamic(confs: DynamicPropertyConf[], specs: DynamicPropertySpec[]): void {
    for (const conf of confs) {
      const dynamicSpec = specs.find((spec) => spec?.id === conf?.dynamicPropertySpecId)

      if (dynamicSpec) {
        conf.spec = dynamicSpec

        // Conditions
        this.populateConstraints(conf.conditions, dynamicSpec.conditions)

        // Properties
        this.populate(conf.properties, dynamicSpec.properties)
      } else {
        this.log.warn(
          'Failed to populate. Could not find DynamicPropertySpec with id ' +
            conf?.dynamicPropertySpecId
        )
      }
    }
  }

  /***************************************************************************
   *                                                                         *
   * Private methods                                                         *
   *                                                                         *
   **************************************************************************/

  private static populateConstraints(confs: ConstraintConf[], specs: ConstraintSpec[]): void {
    for (const conf of confs) {
      conf.spec = specs.find((s) => s.id === conf.constraintSpecId)
    }
  }
}
